export default __webpack_public_path__ + "static/media/Group 89 (1) (1).c8d7fcfc.png";